import React, { useEffect, useState } from "react";
import { Grid, Button, CircularProgress } from "@mui/material";
import { FieldArray, useFormikContext } from "formik";
import POItemRowService from "../../molecules/PurchaseOrder/POItemRowService";
import LGItemCellHeader from "../../atoms/Common/LGItemCellHeader";
import { useCompany } from "../../contexts/CompanyContext";
import { getCatalogue } from "../../api/common/catalogues.ts";
import { useSnack } from "../../services/SnakbarProvider";
import { handleError } from "../../services/errorHandler";

const PODetailTableService = ({ items, expenseAccounts, units }) => {
  const { selectedCompany } = useCompany();
  const { values } = useFormikContext();
  const { openSnack } = useSnack();
  const companyId = selectedCompany?.id;
  const isImport = values.purchaseOrder?.isImport || false;
  const [loading, setLoading] = useState(false);

  const [assetTypeOptions, setAssetTypeOptions] = useState([]);


  const fetchAssetTypes = async () => {
    setLoading(true);
    try {
      const res = await getCatalogue({ CatalogueName: "ASSET_TYPE" });
      setAssetTypeOptions(res.data);
    } catch (e) {
      openSnack(handleError(e), "error");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAssetTypes();
  }, []);

  return (
    loading ? (
      <CircularProgress />
    ) : (
      <Grid container rowSpacing={0} columnSpacing={0}>
        <Grid item xs={1}>
          <LGItemCellHeader label={"Actividad"} />
        </Grid>
        <Grid item xs={1}>
          <LGItemCellHeader label={"Cantidad"} />
        </Grid>
        <Grid item xs={1}>
          <LGItemCellHeader label={"Unidad"} />
        </Grid>
        <Grid item xs={2}>
          <LGItemCellHeader label={"Concepto"} />
        </Grid>
        <Grid item xs={1}>
          <LGItemCellHeader label={"Tipo de activo fijo"} />
        </Grid>
        <Grid item xs={1}>
          <LGItemCellHeader label={"Unidad o bien"} />
        </Grid>
        <Grid item xs={1}>
          <LGItemCellHeader label={"Precio unitario"} />
        </Grid>
        <Grid item xs={1}>
          <LGItemCellHeader label={"Descuento (%)"} />
        </Grid>
        <Grid item xs={1}>
          <LGItemCellHeader label={"Subtotal"} />
        </Grid>
        <Grid item xs={1}>
          <LGItemCellHeader label={"Tasa IVA"} />
        </Grid>
        <Grid item xs={1}>
          <LGItemCellHeader label={"Eliminar"} color={"error.main"} />
        </Grid>

        <FieldArray name="items">
          {({ push, remove }) => (
            <>
              {items.length > 0 && !loading &&
                items.map((item, index) => (
                  <Grid item xs={12} key={index}>
                    <POItemRowService
                      index={index}
                      remove={remove}
                      expenseAccounts={expenseAccounts}
                      companyId={companyId}
                      units={units}
                      assetTypeOptions={assetTypeOptions}
                    />
                  </Grid>
                ))}
              <Grid item xs={12}>
                <Button
                  fullWidth
                  variant="contained"
                  color="secondary"
                  onClick={() =>
                    push({
                      quantity: 0,
                      price: 0,
                      unitId: "",
                      concept: "",
                      assetTypeId: "",
                      assetTypeCode: "",
                      assetId: "",
                      discountPercentage: 0,
                      taxRate: isImport ? 0 : 16,
                      subtotal: 0,
                    })
                  }
                >
                  Agregar Concepto
                </Button>
              </Grid>
            </>
          )}
        </FieldArray>
      </Grid>
    )
  )
};

export default PODetailTableService;
